"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const goober_1 = require("goober");
const open_sans_v15_latin_greek_cyrillic_300_woff_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-300.woff"));
const open_sans_v15_latin_greek_cyrillic_300_woff2_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-300.woff2"));
const open_sans_v15_latin_greek_cyrillic_300italic_woff_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-300italic.woff"));
const open_sans_v15_latin_greek_cyrillic_300italic_woff2_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-300italic.woff2"));
const open_sans_v15_latin_greek_cyrillic_600_woff_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-600.woff"));
const open_sans_v15_latin_greek_cyrillic_600_woff2_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-600.woff2"));
const open_sans_v15_latin_greek_cyrillic_600italic_woff_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-600italic.woff"));
const open_sans_v15_latin_greek_cyrillic_600italic_woff2_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-600italic.woff2"));
const open_sans_v15_latin_greek_cyrillic_700_woff_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-700.woff"));
const open_sans_v15_latin_greek_cyrillic_700_woff2_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-700.woff2"));
const open_sans_v15_latin_greek_cyrillic_700italic_woff_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-700italic.woff"));
const open_sans_v15_latin_greek_cyrillic_700italic_woff2_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-700italic.woff2"));
const open_sans_v15_latin_greek_cyrillic_800_woff_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-800.woff"));
const open_sans_v15_latin_greek_cyrillic_800_woff2_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-800.woff2"));
const open_sans_v15_latin_greek_cyrillic_800italic_woff_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-800italic.woff"));
const open_sans_v15_latin_greek_cyrillic_800italic_woff2_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-800italic.woff2"));
const open_sans_v15_latin_greek_cyrillic_italic_woff_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-italic.woff"));
const open_sans_v15_latin_greek_cyrillic_italic_woff2_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-italic.woff2"));
const open_sans_v15_latin_greek_cyrillic_regular_woff_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-regular.woff"));
const open_sans_v15_latin_greek_cyrillic_regular_woff2_1 = __importDefault(require("./assets/fonts/open-sans-v15-latin_greek_cyrillic-regular.woff2"));
/* eslint-disable-next-line no-unused-expressions */
(0, goober_1.glob) `
    @font-face {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 300;
        src: local('Open Sans Light'), local('OpenSans-Light'), url(${open_sans_v15_latin_greek_cyrillic_300_woff2_1.default}) format('woff2'),
            url(${open_sans_v15_latin_greek_cyrillic_300_woff_1.default}) format('woff');
    }
`;
(0, goober_1.glob) `
    @font-face {
        font-family: 'Open Sans';
        font-style: italic;
        font-weight: 300;
        src: local('Open Sans Light Italic'), local('OpenSans-LightItalic'),
            url(${open_sans_v15_latin_greek_cyrillic_300italic_woff2_1.default}) format('woff2'), url(${open_sans_v15_latin_greek_cyrillic_300italic_woff_1.default}) format('woff');
    }
`;
(0, goober_1.glob) `
    @font-face {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 400;
        src: local('Open Sans Regular'), local('OpenSans-Regular'),
            url(${open_sans_v15_latin_greek_cyrillic_regular_woff2_1.default}) format('woff2'), url(${open_sans_v15_latin_greek_cyrillic_regular_woff_1.default}) format('woff');
    }
`;
(0, goober_1.glob) `
    @font-face {
        font-family: 'Open Sans';
        font-style: italic;
        font-weight: 400;
        src: local('Open Sans Italic'), local('OpenSans-Italic'),
            url(${open_sans_v15_latin_greek_cyrillic_italic_woff2_1.default}) format('woff2'), url(${open_sans_v15_latin_greek_cyrillic_italic_woff_1.default}) format('woff');
    }
`;
(0, goober_1.glob) `
    @font-face {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 600;
        src: local('Open Sans SemiBold'), local('OpenSans-SemiBold'),
            url(${open_sans_v15_latin_greek_cyrillic_600_woff2_1.default}) format('woff2'), url(${open_sans_v15_latin_greek_cyrillic_600_woff_1.default}) format('woff');
    }
`;
(0, goober_1.glob) `
    @font-face {
        font-family: 'Open Sans';
        font-style: italic;
        font-weight: 600;
        src: local('Open Sans SemiBold Italic'), local('OpenSans-SemiBoldItalic'),
            url(${open_sans_v15_latin_greek_cyrillic_600italic_woff2_1.default}) format('woff2'), url(${open_sans_v15_latin_greek_cyrillic_600italic_woff_1.default}) format('woff');
    }
`;
(0, goober_1.glob) `
    @font-face {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        src: local('Open Sans Bold'), local('OpenSans-Bold'), url(${open_sans_v15_latin_greek_cyrillic_700_woff2_1.default}) format('woff2'),
            url(${open_sans_v15_latin_greek_cyrillic_700_woff_1.default}) format('woff');
    }
`;
(0, goober_1.glob) `
    @font-face {
        font-family: 'Open Sans';
        font-style: italic;
        font-weight: 700;
        src: local('Open Sans Bold Italic'), local('OpenSans-BoldItalic'),
            url(${open_sans_v15_latin_greek_cyrillic_700italic_woff2_1.default}) format('woff2'), url(${open_sans_v15_latin_greek_cyrillic_700italic_woff_1.default}) format('woff');
    }
`;
(0, goober_1.glob) `
    @font-face {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 800;
        src: local('Open Sans ExtraBold'), local('OpenSans-ExtraBold'),
            url(${open_sans_v15_latin_greek_cyrillic_800_woff2_1.default}) format('woff2'), url(${open_sans_v15_latin_greek_cyrillic_800_woff_1.default}) format('woff');
    }
`;
(0, goober_1.glob) `
    @font-face {
        font-family: 'Open Sans';
        font-style: italic;
        font-weight: 800;
        src: local('Open Sans ExtraBold Italic'), local('OpenSans-ExtraBoldItalic'),
            url(${open_sans_v15_latin_greek_cyrillic_800italic_woff2_1.default}) format('woff2'), url(${open_sans_v15_latin_greek_cyrillic_800italic_woff_1.default}) format('woff');
    }
`;
//# sourceMappingURL=fonts.js.map